import React from 'react';
import { TrendingUp, Users, Globe, Award, CheckCircle2 } from 'lucide-react';

const Stats = () => {
  const stats = [
    {
      icon: TrendingUp,
      value: '125+',
      label: 'National & International Projects',
      description: 'Successfully delivered for global clients worldwide',
      color: 'from-orange-500 to-amber-600'
    },
    {
      icon: Globe,
      value: '10+',
      label: 'Countries Served',
      description: 'Worldwide presence across US, UK, Europe & Asia',
      color: 'from-cyan-500 to-blue-600'
    },
    {
      icon: Users,
      value: '98%',
      label: 'Customer Retention',
      description: 'Long-term partnerships and recurring engagements',
      color: 'from-blue-500 to-indigo-600'
    },
    {
      icon: Award,
      value: '14+ Yrs',
      label: 'Industry Experience',
      description: 'Dedicated expertise in cutting-edge tech',
      color: 'from-amber-500 to-orange-600'
    }
  ];

  return (
    <section className="py-24 bg-slate-50 text-left relative overflow-hidden border-t border-b border-gray-200">
      {/* Running Motion Animated Mesh & Motion Background Orbs */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#cbd5e180_1px,transparent_1px),linear-gradient(to_bottom,#cbd5e180_1px,transparent_1px)] bg-[size:3rem_3rem] pointer-events-none animate-pulse opacity-70" />
      <div className="absolute -top-20 left-1/4 w-96 h-96 bg-gradient-to-tr from-cyan-300/30 via-blue-200/30 to-transparent rounded-full blur-3xl pointer-events-none animate-[ping_10s_ease-in-out_infinite]" />
      <div className="absolute -bottom-20 right-1/4 w-96 h-96 bg-gradient-to-br from-orange-300/30 via-amber-200/30 to-transparent rounded-full blur-3xl pointer-events-none animate-[pulse_7s_ease-in-out_infinite]" />

      <div className="container mx-auto px-6 relative z-10">

        {/* Section Header */}
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 text-left">
            <div className="inline-flex items-center space-x-2 bg-orange-100/80 border border-orange-200 rounded-full px-4 py-1.5 mb-4 shadow-sm">
              <CheckCircle2 className="w-4 h-4 text-orange-600" />
              <span className="text-orange-800 text-sm font-mono font-bold uppercase tracking-wider">
                Digital Partners in Growth
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4">
              Empowering Your Business Through <span className="bg-gradient-to-r from-orange-600 via-amber-500 to-cyan-600 bg-clip-text text-transparent">Expert Digital Solutions</span>
            </h2>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed">
              We empower businesses to streamline their operations with innovative, high-performance digital solutions. Specializing in web design, enterprise software, and mobile apps, our experts create impactful strategies that help you stand out.
            </p>
          </div>

          {/* Stats Grid */}
          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="group relative bg-white border border-gray-200 rounded-2xl p-6 hover:border-cyan-500/80 transition-all duration-300 hover:scale-[1.03] shadow-sm hover:shadow-xl hover:shadow-cyan-500/10"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 bg-gradient-to-br ${stat.color} rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-md`}>
                    <stat.icon className="w-6 h-6 text-white" />
                  </div>
                  <div className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight">
                    {stat.value}
                  </div>
                </div>

                <div className="text-base font-bold text-gray-900 mb-1">{stat.label}</div>
                <div className="text-base text-gray-500">{stat.description}</div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Stats;